import type { ConceptDef } from '../types';

export const mandHelp: ConceptDef = {
  kind: 'supervisorScored',
  id: 'mand-help',
  label: 'Mand Help',
  category: 'Mand',
  description: 'Present a stuck task; learner asks for help. Supervisor scores.',
  config: {
    promptMode: 'TEXT',
    prompts: [
      { prompt: 'A jar with a tight lid.', hint: 'Expect: "Help please."' },
      { prompt: 'Shoelaces untied.' },
      { prompt: 'Crayon out of reach.' },
      { prompt: "A door that won't open." },
      { prompt: 'A zipper that is stuck.' },
    ],
  },
};
